package kz.dentalcrm.app.screens.appointments.mvi

import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kotlinx.datetime.LocalDate
import kz.dentalcrm.app.core.base.Selectable
import kz.dentalcrm.app.core.ui.ScreenState
import kz.dentalcrm.app.data.network.response_model.employees.Employee
import kz.dentalcrm.app.screens.appointments.mvi.models.UIAppointment

import kotlinx.collections.immutable.PersistentMap
import kotlinx.collections.immutable.persistentMapOf

data class AppointmentsViewState(
    val dateFrom: LocalDate? = null,
    val dateTo: LocalDate? = null,
    val selectedDate: LocalDate? = null,
    val selectedEmployee: Employee? = null,
    val appointmentsByEmployee: PersistentMap<Employee, PersistentList<UIAppointment>> = persistentMapOf(),
    val allAppointments: PersistentList<UIAppointment> = persistentListOf(),
    val employees: PersistentList<Employee> = persistentListOf(),
    val screenState: ScreenState = ScreenState.Loading,
)
